import { render } from "./Playground.vue?vue&type=template&id=5ce6fb92&scoped=true"
import script from "./Playground.vue?vue&type=script&lang=js"
export * from "./Playground.vue?vue&type=script&lang=js"

import "./Playground.vue?vue&type=style&index=0&id=5ce6fb92&scoped=true&lang=css"

import exportComponent from "E:\\c2stem\\c2stem-classroom\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce6fb92"]])

export default __exports__